module.exports = "/_next/static/images/643ebb5cdb22131be0df838e4d6a7ec5-blog-15x.jpg";